var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 454.1 122.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcd404;\n      }\n\n      .cls-2 {\n        fill: #14327d;\n      }\n\n      .cls-3 {\n        fill: #58b947;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.4,98.9c-11.1,0-22.3-3.9-31.1-11.7l9.5-11.4c6.6,5.4,13.5,8.9,21.9,8.9,6.6,0,10.6-2.6,10.6-6.9v-.2c0-4.1-2.5-6.2-14.8-9.3-14.8-3.8-24.3-7.8-24.3-22.4v-.2c0-13.3,10.7-22.1,25.6-22.1,10.7,0,19.8,3.3,27.2,9.3l-8.4,12.1c-6.5-4.5-12.9-7.2-19-7.2s-9.4,2.8-9.4,6.4v.2c0,4.8,3.1,6.4,15.8,9.6,14.9,3.9,23.2,9.2,23.2,22v.2c.1,14.6-11,22.7-26.8,22.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.5,97.9h-28.6V24.7h28.6c23,0,38.9,15.8,38.9,36.4v.2c0,20.6-15.9,36.6-38.9,36.6Zm22.1-36.6c0-13-8.9-22.1-22.1-22.1h-12.5v44.2h12.5c13.2,0,22.1-8.9,22.1-21.9v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M331.8,99.2c-22.8,0-38.5-16-38.5-37.7v-.2c0-20.8,16.2-37.9,38.4-37.9,13.2,0,21.1,3.6,28.8,10l-10.2,12.2c-5.7-4.7-10.7-7.4-19.1-7.4-11.7,0-21,10.4-21,22.8v.2c0,13.4,9.2,23.2,22.2,23.2,5.9,0,11.1-1.5,15.2-4.4v-10.5h-16.2v-13.9h31.8v31.8c-7.7,6.5-18,11.8-31.4,11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M374.9,97.9V24.7h55.3v14.3h-39.2v14.9h34.5v14.3h-34.5v15.4h39.8v14.3h-55.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M439.7,34.2h-1.7v-8h-3v-1.6h7.7v1.6h-3v8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M449.3,31.8h0l-3-4.5v6.8h-1.6v-9.5h1.8l2.9,4.5,2.9-4.5h1.8v9.5h-1.7v-6.8l-3.1,4.5Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.3,34.4c-12.7,12-59.4,42.4-115,40.3,3.2,14.9,11.3,24.2,11.3,24.2,34.7-2.4,89.8-39.6,108-52.9-1-3.9-2.5-8-4.3-11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.7,46s-26,42-90.9,68.1c5.9,3.5,16.7,8.5,29.1,8.6,15.8,.2,26.5-3.6,37.3-10.8,8.9-5.9,17.6-16.6,21.8-27.3,3-7.5,4.7-15.5,4.7-23.5-.1-5.1-.8-10.3-2-15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.2,14.9C90.5,5.6,76.5,0,61.2,0,27.3,0,0,27.4,0,61.3c0,4.5,.5,9.1,1.4,13.3-.1,.1,68.5-9.6,99.8-59.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.21c4f0f0eaa65dda58687f020e603f52.svg";
export { ForwardRef as ReactComponent };